import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/auth/auth.guard';
import { Steps } from './core/enums/steps';

const routes: Routes = [
  {
    path: 'home',
    loadComponent: () => import('./pages/step0/step0.component').then(m => m.Step0Component)
  },
  {
    path: '', redirectTo: '/home', pathMatch: 'full'
  },
  {
    path: '',
    canActivate: [AuthGuard],
    children: [
      {
        path: 'step1',
        loadComponent: () => import('./pages/steps/step1/step1.component').then(m => m.Step1Component),
        data: { stepId: 1, stepName: Steps[1], eventName: 'Lead journey started' }
      },
      {
        path: 'step2',
        loadComponent: () => import('./pages/steps/step2/step2.component').then(m => m.Step2Component),
        data: { stepId: 2, stepName: Steps[2], eventName: 'Lead to sign WP' }
      },
      {
        path: 'step5',
        loadComponent: () => import('./pages/steps/step5/step5.component').then(m => m.Step5Component),
        data: { stepId: 5, stepName: Steps[5], eventName: 'OTP started' }
      },
      {
        path: 'step6',
        loadComponent: () => import('./pages/steps/step6/step6.component').then(m => m.Step6Component),
        data: { stepId: 6, stepName: Steps[6], eventName: 'Lead sees quote' }
      },
      {
        path: 'step7',
        loadComponent: () => import('./pages/steps/step7/step7.component').then(m => m.Step7Component),
        data: { stepId: 7, stepName: Steps[7], eventName: 'Lead sees DC explanation' }
      },
      {
        path: 'step9',
        loadComponent: () => import('./pages/steps/step9/step9.component').then(m => m.Step9Component),
        data: { stepId: 9, stepName: Steps[9], eventName: 'Security Questions Set 1 started' }
      },
      {
        path: 'step10',
        loadComponent: () => import('./pages/steps/step10/step10.component').then(m => m.Step10Component),
        data: { stepId: 10, stepName: Steps[10], eventName: 'Security Questions Set 2 started' }
      },
      {
        path: 'step11',
        loadComponent: () => import('./pages/steps/step11/step11.component').then(m => m.Step11Component),
        data: { stepId: 11, stepName: Steps[11], eventName: 'Lead journey started' }
      },
      {
        path: 'step12',
        loadComponent: () => import('./pages/steps/step12/step12.component').then(m => m.Step12Component),
        data: { stepId: 12, stepName: Steps[12], eventName: 'Lead to enter SA ID' }
      },
      {
        path: 'step13',
        loadComponent: () => import('./pages/steps/step13/step13.component').then(m => m.Step13Component),
        data: { stepId: 13, stepName: Steps[13], eventName: 'To create DBC password' }
      },
      {
        path: 'step15',
        loadComponent: () => import('./pages/steps/step15/step15.component').then(m => m.Step15Component),
      },
      {
        path: 'step18',
        loadComponent: () => import('./pages/steps/step18/step18.component').then(m => m.Step18Component)
      },
      {
        path: 'step19',
        loadComponent: () => import('./pages/steps/step19/step19.component').then(m => m.Step19Component),
        data: { stepId: 19, stepName: Steps[19], eventName: 'Security Questions' }
      },

      {
        path: 'step20',
        loadComponent: () => import('./pages/steps/step20/step20.component').then(m => m.Step20Component),
        data: { stepId: 20, stepName: Steps[20], eventName: 'Referral started' }
      },
      {
        path: 'step21',
        loadComponent: () => import('./pages/steps/step21/step21.component').then(m => m.Step21Component),
        data: { stepId: 21, stepName: Steps[21], eventName: 'JM MMS started' }
      },
      {
        path: 'step22',
        loadComponent: () => import('./pages/steps/step22/step22.component').then(m => m.Step22Component),
        data: { stepId: 22, stepName: Steps[22], eventName: 'Payment confirmation' }
      },
      {
        path: 'step26',
        loadComponent: () => import('./pages/steps/step26/step26.component').then(m => m.Step26Component),
        data: { stepId: 26, stepName: Steps[26], eventName: 'Payment waiting' }
      },
      {
        path: 'step29',
        loadComponent: () => import('./pages/steps/step29/step29.component').then(m => m.Step29Component),
        data: { stepId: 29, stepName: Steps[29], eventName: 'JM lgl ins landing' }
      },
      {
        path: 'step30',
        loadComponent: () => import('./pages/steps/step30/step30.component').then(m => m.Step30Component),
        data: { stepId: 30, stepName: Steps[30], eventName: 'Choose your package Screen' }
      },
      {
        path: 'step31',
        loadComponent: () => import('./pages/steps/step31/step31.component').then(m => m.Step31Component),
        data: { stepId: 31, stepName: Steps[31], eventName: 'JM standard legal insurance personal details' }
      }
      ,
      {
        path: 'step32',
        loadComponent: () => import('./pages/steps/step32/step32.component').then(m => m.Step32Component),
        data: { stepId: 32, stepName: Steps[32], eventName: 'T&Cs' }
      },
      {
        path: 'step33',
        loadComponent: () => import('./pages/steps/step33/step33.component').then(m => m.Step33Component),
        data: { stepId: 33, stepName: Steps[33], eventName: 'Securely set up your monthly payment' }
      },
      {
        path: 'step34',
        loadComponent: () => import('./pages/steps/step34/step34.component').then(m => m.Step34Component),
        data: { stepId: 34, stepName: Steps[34], eventName: 'Banking details' }
      },
      {
        path: 'step39',
        loadComponent: () => import('./pages/steps/step39/step39.component').then(m => m.Step39Component),
        data: { stepId: 39, stepName: Steps[39], eventName: 'API waiting screen' }
      },
      {
        path: 'step43',
        loadComponent: () => import('./pages/steps/step43/step43.component').then(m => m.Step43Component),
        data: { stepId: 43, stepName: Steps[43], eventName: 'Match landing screen' }
      },
      {
        path: 'step45',
        loadComponent: () => import('./pages/steps/step45/step45.component').then(m => m.Step45Component),
        data: { stepId: 45, stepName: Steps[45], eventName: 'Binary security questions' }
      }
    ]
  },
  {
    path: 'exitstep',
    loadComponent: () => import('./pages/exit-step/exit-step.component').then(m => m.ExitStepComponent)
  },
  {
    path: 'process-failed',
    loadComponent: () => import('./pages/process-failed/process-failed.component').then(m => m.ProcessFailedComponent)
  },
  {
    path: 'session-timeout',
    loadComponent: () => import('./pages/session-timeout/session-timeout.component').then(m => m.SessionTimeoutComponent)
  },
  {
    path: ':key',
    loadComponent: () => import('./pages/step0/step0.component').then(m => m.Step0Component)
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
